// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3_YCo","fileBtn":"File_fileBtn__1THa9","closeBtn":"File_closeBtn__1xeQM","fileSelected":"File_fileSelected__r1pcf","disabled":"File_disabled__3R1Ui"};